var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.09 44.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f19149;}.cls-2{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Keywords"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22.045,
    cy: 22.045,
    r: 22.045
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17,30.741A3.5,3.5,0,0,1,13.352,27.1a41.578,41.578,0,0,1-.125-4.323,42.09,42.09,0,0,1,.123-4.321,3.486,3.486,0,0,1,3.636-3.64A42.164,42.164,0,0,1,21.31,14.7h.022a.735.735,0,1,1-.022,1.469c-1.833,0-3.2.006-4.159.114a2.1,2.1,0,0,0-2.342,2.344c-.109.961-.112,2.325-.112,4.156s.006,3.2.116,4.155a2.1,2.1,0,0,0,2.351,2.345c.96.109,2.322.113,4.148.113s3.188,0,4.148-.114a2.108,2.108,0,0,0,2.351-2.352,41.471,41.471,0,0,0,.116-4.15v-.02a.735.735,0,0,1,1.47.02,41.463,41.463,0,0,1-.126,4.317,3.5,3.5,0,0,1-3.645,3.641,41.715,41.715,0,0,1-4.316.128h-.22A39.658,39.658,0,0,1,17,30.741Zm3.578-6.491a.735.735,0,0,1-.734-.735V21.31a.732.732,0,0,1,.214-.519l8.818-8.818a.735.735,0,0,1,1.039,0l2.2,2.2a.735.735,0,0,1,0,1.039L23.3,24.034a.738.738,0,0,1-.519.216Zm.735-2.636V22.78h1.166L28.354,16.9l-1.165-1.165ZM28.228,14.7l1.165,1.165L30.559,14.7l-1.166-1.166Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtract);
export default __webpack_public_path__ + "static/media/extract.7775e286ee731afd8757f3b9e3e0249a.svg";
export { ForwardRef as ReactComponent };